import { Box, keyframes, styled } from '@mui/material';
import Logo from 'assets/img/company.png';
import React from 'react';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  animation: `${fadeIn} 0.3s ease-in-out`,
}));

const Spinner = styled('div')(({ theme }) => ({
  width: 50,
  height: 50,
  border: `3px solid ${theme.palette.primary.light}`,
  borderTop: `3px solid ${theme.palette.primary.main}`,
  borderRadius: '50%',
  animation: `${spin} 1s linear infinite`,
  marginBottom: theme.spacing(2),
}));

const LogoContainer = styled(Box)({
  width: 80,
  height: 80,
  marginBottom: 24,
  '& svg': {
    width: '100%',
    height: '100%',
  },
});

const AppLoader: React.FC = () => {
  return (
    <LoadingContainer>
      <LogoContainer>
        <img
          src={Logo}
          alt="Loading..."
          style={{ width: '100%', height: '100%' }}
        />
      </LogoContainer>
      <Spinner />
    </LoadingContainer>
  );
};

export default AppLoader;
